<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="PropertyId"
      ref="list"
      unit="采购发票"
      :expand-all-row="true"
      :page="page"
      :show-checkbox="true"
      :show-query="true"
      :query-params="params"
      :get-data-func="api.list"
      @showRow="showRow"
      :temp-parpams="tempParams"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>

    <!-- 明细 -->
    <el-button
      v-if="show"
      type="primary"
      @click="onCustomTable"
      icon="el-icon-s-tools"
      style="margin: 30px 0 10px 10px"
    >
      明细项
    </el-button>
    <el-table
      ref="multipleTable"
      :row-key="(row) => row.Prop"
      :data="subList"
      v-if="show"
      stripe
      border
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        v-if="is_listDialog"
        type="selection"
        width="55"
      ></el-table-column>
      <template v-for="(item, index) in tableColumns">
        <!-- 需判断是否有价格的权限  -->
        <template v-if="item.IsShow">
          <el-table-column
            :resizable="false"
            :key="`${item.Prop}-${index}`"
            :prop="item.Prop"
            v-if="shouldShowColumn(item)"
            :label="item.Label"
            :align="item.Align ?? 'left'"
            :min-width="item.Width"
            show-overflow-tooltip
          >
            <template slot-scope="{ row }">
              <span v-if="isNumericProperty(item.Prop)">
                {{ $commonJs.toThousands(row[item.Prop]) }}
              </span>
              <span v-else>
                {{ row[item.Prop] }}
              </span>
            </template>
          </el-table-column>
        </template>
      </template>
    </el-table>
    <customTableDialog
      ref="customTableDialog"
      @onSave="onSave"
      :initTableData="tableColumns"
      tableType="采购发票明细"
    />
    <!-- <el-table class="subItem-table" :data="subList" tooltip-effect="dark" v-if="show" @selection-change="handleSelectionChange" border>
      <el-table-column v-if="is_listDialog" type="selection" width="55">
      </el-table-column>
      <el-table-column align="left" prop="ProductName" label="存货编码" min-width="140" show-overflow-tooltip></el-table-column>
      <el-table-column align="left" prop="ProductNo" label="存货名称"></el-table-column>
      <el-table-column align="left" prop="ProductSpec" label="规格"></el-table-column>
      <el-table-column align="left" prop="ColorName" label="颜色"></el-table-column>
      <el-table-column align="left" prop="PuUnitName" label="计量单位"></el-table-column>
      <el-table-column align="right" prop="PuQuantity" label="数量">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.PuQuantity) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" prop="Price" label="单价" v-if="canPrice"></el-table-column>
      <el-table-column align="right" prop="Amount" label="金额" v-if="canPrice">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.Amount) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" prop="Rate" label="税率" v-if="canPrice"></el-table-column>
      <el-table-column align="right" prop="TaxPrice" label="含税单价" v-if="canPrice"></el-table-column>
      <el-table-column align="right" prop="TaxAmount" label="含税金额" v-if="canPrice">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.TaxAmount) }}</span>
        </template>
      </el-table-column>
    </el-table> -->
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";
import customTableDialog from "@/components/common/customTableDialog/customTableDialog";

export default {
  mixins: [listMixin],
  components: { list, customTableDialog },
  provide() {
    return {
      IsDefaultMonth: false,
    };
  },
  data() {
    return {
      api: require("@/api/pu/puBill").default,
      FieldSettingApi: require("@/api/sy/fieldSetting").default,
      show: false,
      orderNo: "",
      subSelectList: [],
      subList: [],
      params: {
        RankName: "",
      },
      tempParams: {
        SortName: "OrderDate",
        SortOrder: "DESC",
      },
      tableColumns: [],
    };
  },
  props: {
    isShow: {
      type: Boolean,
      default: true,
    },
    is_listDialog: {
      typeof: Boolean,
      default: false,
    },
    isSelect: {
      typeof: Boolean,
      default: false,
    },
    // canPrice: {
    //   type: Boolean,
    //   default: true,
    // },
  },

  computed: {
    canPrice() {
      return this.$permission.canPrice("/business/purchase/purchaseinvoice");
    },
  },
  mounted() {
    this.getTableColumns();
  },
  methods: {
    /** 价格权限的字段 */
    shouldShowColumn(item) {
      if (!item.IsShow) return false;
      const priceProps = [
        "PurchasePrice",
        "SalePrice",
        "RetailPrice",
        "QuotedPrice",
        "Discount",
        "TaxRate",
        "Price",
        "TaxPrice",
        "Amount",
        "TaxLimit",
        "TaxAmount",
        "DiscountAmount",
        "Rate",
        "Price",
      ];
      return (
        (this.canPrice && priceProps.includes(item.Prop)) ||
        !priceProps.includes(item.Prop)
      );
    },
    /** 千位符格式化数字类型 */
    isNumericProperty(prop) {
      return ["PuQuantity", "Amount", "TaxAmount"].includes(prop);
    },
    async getTableColumns() {
      const res = await this.FieldSettingApi.list({ Type: "采购发票明细" });
      this.tableColumns = [];
      this.tableColumns = res.Data;
    },
    onCustomTable() {
      this.$refs.customTableDialog.dialogVisible = true;
    },
    onSave() {
      this.getTableColumns();
      this.$message.success("保存成功");
    },

    // 选择报价明细
    handleSelectionChange(data) {
      this.subSelectList = data;
    },
    showRow(data) {
      // console.log('当前行');
      // if (!this.is_listDialog) return;
      this.show = false;
      this.api.info(data.DocId).then((res) => {
        if (res.Code === 0 && res.Data.length != 0) {
          this.show = true;
          this.orderNo = res.Data.DocNo;
          this.subList = res.Data.Products;
        }
      });
      // this.subList.push(data)
    },
    delRange(Ids) {
      this.api.delete({ Ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.subItem-table {
  margin-top: 30px;
}
</style>
